import { Routes } from "@angular/router";
import { DefaultLayoutComponent } from "./layout/default-layout/default-layout.component";
import { AuthGuardService } from "./services/auth.guard.service";

export const routes: Routes = [
  {
    path: "auth",
    loadComponent: () => import('./auth/auth.component').then(m => m.AuthComponent),
  },
  {
    path: "dashboard",
    component: DefaultLayoutComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./views/dashboard/routes').then((m) => m.routes)
  },
  {
    path: "theme",
    component: DefaultLayoutComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./views/theme/routes').then((m) => m.routes)
  },
  {
    path: "base",
    component: DefaultLayoutComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./views/base/routes').then((m) => m.routes)
  },
  {
    path: "buttons",
    component: DefaultLayoutComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./views/buttons/routes').then((m) => m.routes)
  },
  {
    path: "forms",
    component: DefaultLayoutComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./views/forms/routes').then((m) => m.routes)
  },
  {
    path: "icons",
    component: DefaultLayoutComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./views/icons/routes').then((m) => m.routes)
  },
  {
    path: "notifications",
    component: DefaultLayoutComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./views/notifications/routes').then((m) => m.routes)
  },
  {
    path: "widgets",
    component: DefaultLayoutComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./views/widgets/routes').then((m) => m.routes)
  },
  {
    path: "charts",
    component: DefaultLayoutComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./views/charts/routes').then((m) => m.routes)
  },
  {
    path: "devices",
    component: DefaultLayoutComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./views/devices/routes').then((m) => m.routes)
  },
  {
    path: "monitoring",
    component: DefaultLayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: "kuma",
        loadChildren: () => import('./views/monitoring/routes').then((m) => m.routes)
      },
      {
        path: "kuma-oregon",
        loadChildren: () => import('./views/monitoring-oregon/routes').then((m) => m.routes)
      },
      {
        path: "",
        redirectTo: "kuma",
        pathMatch: "full"
      }
    ]
  },
  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
  {
    path: "**",
    redirectTo: "dashboard"
  }
];